import { render, staticRenderFns } from "./preservationNotice.vue?vue&type=template&id=2215c738&scoped=true&"
import script from "./preservationNotice.vue?vue&type=script&lang=js&"
export * from "./preservationNotice.vue?vue&type=script&lang=js&"
import style0 from "./preservationNotice.vue?vue&type=style&index=0&id=2215c738&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2215c738",
  null
  
)

export default component.exports